<template>
  <div class="container-fluid mt-2">
    <h2>Artikeldaten</h2>
    <div class="row mt-3">
      <div class="col-md">
        <h4>{{ article.article_nr }}&nbsp;-&nbsp;{{ (article.desc ? article.desc.short_des : '')}}</h4><br/>
      </div>
      <div class="col-md">
        <img style="max-height:200px;" :src="baseurl + 'rest/data/images/' + encodeURIComponent(article.map_pic_id) + '/1'"/>
      </div>
    </div>
    <br/>
    <b-tabs content-class="mt-3">
      <b-tab title="Stammdaten">
        <ArticleData :article="article"/>
      </b-tab>
      <b-tab title="Texte">
        <ArticleText :descid="article.map_desc_id"/>
      </b-tab>
      <b-tab title="Preise">
        <ArticlePrices :priceid="article.map_price_id"/>
      </b-tab>
      <b-tab title="Bilder">
        <ArticleImages :article="article" :baseurl="baseurl"/>
      </b-tab>
      <b-tab title="Nachlieferungen">
        <ArticleReorders :articleid="articleid"/>
      </b-tab>
      <b-tab title="Zusätze">
        <ArticleInfoLinks :articleid="article.map_id"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ArticleInfoLinks from '@/components/articles/ArticleInfoLinks.vue'
import ArticleImages from '@/components/articles/ArticleImages.vue'
import ArticleReorders from '@/components/articles/ArticleReorders.vue'
import ArticlePrices from '@/components/articles/ArticlePrices.vue'
import ArticleText from '@/components/articles/ArticleText.vue'
import ArticleData from '@/components/articles/ArticleData.vue'
import articles from '@/modules/articles.js'
import config from '@/modules/config.js'

export default {
  name: 'ArticleView',
  components: {
    ArticleData,
    ArticleText,
    ArticlePrices,
    ArticleImages,
    ArticleReorders,
    ArticleInfoLinks
  },
  data() {
    return {
      articleid: -1,
      article: {flags:{},quantities:[]},
      baseurl: ''
    }
  },
  created: function() {

    this.baseurl   = config.baseUrl;
    this.articleid = this.$route.params.articleid;
    console.log('set article id: ' + this.articleid);

    var self = this;
    articles.load(this.articleid,function(data) {
      self.article = data;
    });
  }
}
</script>
